import { render, staticRenderFns } from "./PaxList.vue?vue&type=template&id=658f718e&scoped=true&"
import script from "./PaxList.vue?vue&type=script&lang=js&"
export * from "./PaxList.vue?vue&type=script&lang=js&"
import style0 from "./PaxList.vue?vue&type=style&index=0&id=658f718e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658f718e",
  null
  
)

export default component.exports